
import { defineComponent } from 'vue';
import { telefoneLink } from '@/uteis/conteudo';

export default defineComponent({
  name: 'ContatoIndex',
  props: {
    TelefonePrimario: {
        type: String,
        default: ""
    },
    TelefoneSecundario: {
        type: String,
        default: ""
    },
    Logradouro: {
        type: String,
        default: ""
    },
    Cidade: {
        type: String,
        default: ""
    },
    Cep: {
        type: String,
        default: ""
    },
    Pais: {
        type: String,
        default: ""
    },
    DiasAtendimento: {
        type: String,
        default: ""
    },
    HorasAtendimento: {
        type: String,
        default: ""
    },
    TextoWhatsApp: {
        type: String,
        default: ""
    }
  },
  computed: {
    telefoneHref(): string { return telefoneLink(); }
  }
});
